export default [
  {
    path: "/contrato/:id",
    name: "contract-id",
    component: () => import("@/views/contract/Contract.vue"),
    meta: {
      pageTitle: "Contrato",
      breadcrumb: [
        {
          text: "",
        },
      ],
      resource: "Contract",
      action: "read",
    },
  },
  {
    // Pantalla de pago dedicada: destino de los enlaces de integradores
    // externos. layout full porque quien llega solo viene a pagar y la
    // navegación del portal no le sirve — además de que suele venir dentro
    // de un WebView, donde el menú lateral estorba.
    path: "/pagar/:id",
    name: "payment-page",
    component: () => import("@/views/payment/PaymentPage.vue"),
    meta: {
      layout: "full",
      resource: "Contract",
      action: "read",
    },
  },
]
